var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "entitlementsView" }, [
    _c("h1", { staticClass: "admin-header" }, [
      _vm._v("Entitlements "),
      _vm.orgTier
        ? _c("span", { staticClass: "badge" }, [
            _vm._v(_vm._s(_vm.orgTier) + " Tier"),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("h3", [_vm._v("Technology Insights")]),
    _vm._v(" "),
    _c(
      "section",
      { staticClass: "panelRow" },
      [
        _c("utilization-panel", {
          attrs: {
            loading: _vm.loading,
            metricName: "Endpoint",
            "utilization-count": _vm.endpointCount,
            "utilization-limit": _vm.endpointLicenseCount,
          },
        }),
        _vm._v(" "),
        _c("utilization-panel", {
          attrs: {
            loading: _vm.loading,
            metricName: "Meeting User",
            "utilization-count": _vm.meetingUserCount,
            "utilization-limit": _vm.meetingUserLicenseCount,
          },
        }),
        _vm._v(" "),
        _c("utilization-panel", {
          attrs: {
            loading: _vm.loading,
            metricName: "Voice User",
            "utilization-count": _vm.voiceUserCount,
            "utilization-limit": _vm.voiceUserLicenseCount,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("h3", { staticClass: "laterRow" }, [_vm._v("Space Insights")]),
    _vm._v(" "),
    _c(
      "section",
      { staticClass: "panelRow" },
      [
        _c("utilization-panel", {
          attrs: {
            loading: _vm.loading,
            metricName: "Space",
            "utilization-count": _vm.spaceCount,
            "utilization-limit": _vm.spaceLicenseCount,
          },
        }),
        _vm._v(" "),
        _c("utilization-panel", {
          attrs: {
            loading: _vm.loading,
            metricName: "Non-Tech Space",
            "utilization-count": _vm.nonTechSpaceCount,
            "utilization-limit": _vm.nonTechSpaceLicenseCount,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }